"use client";

import { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { captureLogRocketError } from "@/app/lib/logrocket";

/**
 * Route-level error boundary (Next.js App Router).
 * Every render/loader error is reported to LogRocket with the current session,
 * so the replay shows exactly what the user did before the crash.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureLogRocketError(error, {
      boundary: "app/error",
      digest: error.digest ?? "",
    });
  }, [error]);

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        p: 4,
        textAlign: "center",
      }}
    >
      <Typography variant="h5" fontWeight={600}>
        Something went wrong
      </Typography>
      <Typography variant="body2" color="text.secondary">
        The error has been reported automatically. Please try again.
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
        <Button variant="contained" onClick={() => reset()}>
          Try again
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            window.location.href = "/dashboard";
          }}
        >
          Go to dashboard
        </Button>
      </Box>
    </Box>
  );
}
